import { defineMessages } from 'react-intl-next';
export var messages = defineMessages({
  error: {
    id: 'commerce.credit-card-hams.brand-validation.error',
    defaultMessage: 'Only Visa, MasterCard and AMEX are supported',
    description: 'Error message to display when an unsupported credit card brand is entered'
  }
});